import React from 'react';
import { SocketProvider } from './SocketContext';
import { Route } from 'react-router-dom';
import './App.css';
import VideoConferenceModal from './Screen/FaceTalk';
import RoomWithAuth from './Screen/RoomWithAuth';
import Landing from './Screen/Landing';
import Drama from './Screen/Drama';
import { LocaleProvider } from './locale';

// 첫 화면은 앤츠미팅을 알리고 받아 가는 자리다. 예전에는 열자마자 회의가
// 떠서, 처음 온 사람은 여기가 무엇을 하는 곳인지 모른 채 카메라 권한부터
// 물어봐야 했다. 회의는 /meet 으로 옮겼고 주소만 바뀌었다.
const Screen = () => {
  return (
    <div>
      <VideoConferenceModal isOpen={true} roomId="some-room-id" />
    </div>
  );
};

function App() {
  return (
    <LocaleProvider>
    <SocketProvider>
      <div className="App">
        <div id="Contents" className="MasterPanel">
          <Route path="/" exact component={Landing} key="landing" />
          <Route path="/drama" exact component={Drama} key="drama" />
          <Route path="/meet" exact component={Screen} key="face" />
          <Route path="/room/:roomId" exact component={RoomWithAuth} key="room" />
        </div>
      </div>
    </SocketProvider>
    </LocaleProvider>
  );
}

export default App;
